import { connect } from 'react-redux';

import RoomCard from './RoomCard';

const mapStateToProps = (state) => ({
    minLengthOfStay: state.settings.data.minLengthOfStay,
    maxLengthOfStay: state.settings.data.maxLengthOfStay,
    minNightOffset: state.settings.data.minNightOffset,
    maxCheckOutDate: state.settings.data.maxCheckoutDate,
    isMultiProperty: state.settings.data.isMultiProperty,
    calendarPricesMode: state.settings.data.calendarPrices,
    widgetType: state.settings.data.widgetType,
    defaultOccupancy: state.settings.data.defaultOccupancy,
    priceCalcMode: state.settings.data.priceCalcMode,
    priceDisplayMode: state.settings.data.priceDisplayMode,
    minOccupancy: state.settings.data.minOccupancy,
    searchBarExists: state.widgetPool[0].searchbar.isRendered,
    domain: state.settings.data.domain,
    promotionalCodeEnabled: state.settings.data.promotionalCodeEnabled,
    promotionalCode: state.searchParams?.promotionalCode || null,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(RoomCard);
